
import Vue from 'vue';
import FirstStepsSlider from '@/components/helpcenter/firstSteps/FirstStepsSlider.vue';
import FirstStepsButton from '@/components/helpcenter/firstSteps/FirstStepsButton.vue';
import { Icon } from '@descomplica/vue-components';
import { SupportChat } from '@/helpers/supportChat';

interface Article {
  id: number;
  title: string;
  relationships: Array<number>;
  description: string;
  imgs: string;
}
interface Section {
  title: String;
  description: String;
  articles: Array<Article>;
}
export default Vue.extend({
  components: {
    Icon,
    FirstStepsSlider,
    FirstStepsButton,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isOpen: this.open,
      selectedArticle: null as any,
      firstStepsOpen: false as Boolean,
    };
  },
  computed: {
    relatedArticles() {
      const helpCenterSections: [] = this.$t('trial.helpCenterSections') as any;
      const relation: Array<Article> = [];
      const { relationships } = this.selectedArticle;
      helpCenterSections.forEach((section: Section) => {
        section.articles.forEach((article: Article) => {
          if (relationships.includes(article.id)) {
            relation.push(article);
          }
        });
      });

      return relation;
    },
  },
  watch: {
    open() {
      this.isOpen = this.open;
    },
  },
  methods: {
    selectArticleHandler(article?: Article): void {
      if (this.firstStepsOpen) {
        this.firstStepsHandler();
      }

      this.selectedArticle = article;
      // @ts-ignore
      this.$refs.body?.scrollTop({ top: 0, behavior: 'smooth' });
    },
    onScrollToTop(): void {
      // @ts-ignore
      this.$refs.body.scrollTo({ top: 0, behavior: 'smooth' });
    },
    openExternalHelpCenter(): void {
      window.open('https://no.descomplica.com.br/knowledge/gradua%C3%A7%C3%A3o', '_blank');
    },
    openChat(): void {
      SupportChat.openChat();
    },
    getImgSrc(img: string, index: number): string {
      return `${process.env.BASE_URL || ''}img/trial/help-center/${img}-${index}.svg`;
    },
    firstStepsHandler() {
      this.firstStepsOpen = !this.firstStepsOpen;

      // @ts-ignore
      this.$refs.body?.scrollTop = { top: 0, behavior: 'smooth' };
    },
  },
});
